/* MYLOVELYPET approved SHOPIFY theme only (not the Netlify site).
   Captures one signed, server-issued creator ticket and preserves on cart.
   Respect Shopify Customer Privacy; deny tracking when consent API is absent.
   Install only after test checkout and privacy review.
*/
(function(){'use strict';
 const names=['mlp_ref','mlp_click','mlp_exp','mlp_sig'];
 const cartNames=['mlp_creator_ref','mlp_ref_click','mlp_ref_exp','mlp_ref_sig'];
 let active=null;
 function consent(){return window.Shopify?.customerPrivacy?.userCanBeTracked?.()===true}
 function valid(x){return /^[a-f0-9]{18}$/.test(x?.[0]||'')&&/^[0-9a-f-]{36}$/.test(x?.[1]||'')&&
  /^[0-9]{10}$/.test(x?.[2]||'')&&/^[a-f0-9]{64}$/.test(x?.[3]||'')&&Number(x[2])*1000>Date.now()}
 function hydrate(){
  const url=new URL(location.href),q=url.searchParams;
  const vals=names.map(n=>q.get(n));
  // Keep the signed ticket in the URL until consent has been confirmed.
  // No referral data is persisted or attached to cart before consent.
  if(!consent()){try{localStorage.removeItem('mlp_referral_bundle')}catch{};active=null;return}
  if(names.some(n=>q.has(n))){names.forEach(n=>q.delete(n));history.replaceState(null,'',url.pathname+(q.toString()?'?'+q:'')+url.hash)}
  if(valid(vals)){active=vals;try{localStorage.setItem('mlp_referral_bundle',JSON.stringify(vals))}catch{}}
  else{try{const prior=JSON.parse(localStorage.getItem('mlp_referral_bundle')||'null');active=valid(prior)?prior:null}catch{active=null}}
 }
 let inflight=null;
 async function attach(){
  hydrate();if(!active||!consent())return;
  if(inflight)return inflight;
  const attrs=Object.fromEntries(cartNames.map((name,i)=>[name,active[i]]));
  inflight=fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'content-type':'application/json'},body:JSON.stringify({attributes:attrs})})
   .then(r=>{if(!r.ok)throw Error('Cart referral attachment failed');return r.json()}).finally(()=>{inflight=null});
  return inflight;
 }
 hydrate();
 if(window.Shopify?.loadFeatures && !window.Shopify.customerPrivacy){
   window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){
     if(!error){hydrate();attach().catch(()=>{});}
   });
 }
 if(consent())attach().catch(()=>{});
 document.addEventListener('shopify:customer-privacy:consent-changed',()=>{hydrate();attach().catch(()=>{})});
 document.addEventListener('cart:updated',()=>attach().catch(()=>{}));
 // Avoid checkout races. Do not intercept if consent not granted.
 document.addEventListener('submit',function(e){
  const form=e.target;
  if(!consent()||!active||!form?.matches('form[action*="/cart"]')||!e.submitter?.matches('[name="checkout"]'))return;
  e.preventDefault();
  // Calling form.submit() omits the clicked submit button: preserve Shopify's
  // `checkout` field so the shopper proceeds to checkout after attributes sync.
  if(!form.querySelector('input[type="hidden"][name="checkout"]')){
   const checkout=document.createElement('input');checkout.type='hidden';
   checkout.name='checkout';checkout.value=e.submitter?.value||'Checkout';
   form.appendChild(checkout);
  }
  attach().finally(()=>HTMLFormElement.prototype.submit.call(form));
 },true);
 document.addEventListener('click',function(e){
  const a=e.target.closest?.('a[href*="/checkout"]');if(!a||!consent()||!active)return;
  e.preventDefault();attach().finally(()=>{location.href=a.href});
 },true);
})();
